import { ArrowRight } from 'lucide-react'
import { useState } from 'react'
import { cn } from '../utils/cn'

export default function CardServicosVentures({
  text,
  logo,
  glowColor,
  url,
  textSize,
  width,
  height,
  className = '',
}) {
  const [isHovered, setIsHovered] = useState(false)

  function handleMouseEnter() {
    setIsHovered(true)
  }

  function handleMouseLeave() {
    setIsHovered(false)
  }

  const CardContent = () => (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleMouseEnter}
      onTouchEnd={handleMouseLeave}
      className={cn(
        'relative hover:cursor-pointer',
        height ? (window.innerWidth <= 768 ? `h-[full]` : `h-[${height}px]`) : 'h-[350px]',
        width ? `w-[${width}px]` : 'w-[350px]',
        className,
      )}
    >
      <div
        className={`absolute inset-0 transition-opacity duration-300 blur-xl ${
          isHovered ? 'opacity-80' : 'opacity-0'
        }`}
        style={{ backgroundColor: glowColor }}
      />
      <div className="relative z-10 rounded-lg py-10 px-10 bg-[#1B182D] text-white h-full w-full flex flex-col">
        <div className="flex flex-row items-center md:flex-col md:items-start">
          <img src={logo} alt="Logo" className="h-10 object-contain" />
        </div>
        <p
          className={`mt-8 font-inter-regular leading-[1.5] ${
            textSize === 'small' ? 'text-sm' : 'text-xl'
          }`}
        >
          {text}
        </p>
          <div className="mt-auto pt-6 items-center justify-center md:justify-start flex">
            <div className="inline-block px-9 md:px-0 py-3 md:py-1 rounded-full transition-all duration-300 bg-[#FFFFFF14] md:bg-transparent md:flex flex-row">
              <div className="font-inter-light text-base text-white flex items-center">
                Ver mais
                <ArrowRight className="ml-2" width={20} height={20} />
              </div>
            </div>
          </div>
      </div>
    </div>
  )

  return url ? (
    <a href={url} className="block no-underline text-inherit">
      <CardContent />
    </a>
  ) : (
    <CardContent />
  )
}
